// extracted by mini-css-extract-plugin
export default {"CloudinaryImageCard":"CloudinaryImageCard_CloudinaryImageCard__cMFz5"};